/**
 * Tron addresses come in two spellings:
 *   base58  "T…"              — what users see (base58check of 0x41 ‖ 20 bytes)
 *   hex     20 bytes, 40 hex  — what appears in event logs / topics (no 41 prefix)
 */
import { sha256 } from "@noble/hashes/sha2.js";
import { bytesToHex, hexToBytes } from "@noble/hashes/utils.js";
import { createBase58check } from "@scure/base";
const base58check = createBase58check(sha256);
const PREFIX = 0x41;
/** "T…" → 40 lower-case hex chars (no 0x, no 41). Throws on an invalid address. */
export function tronAddressToHex20(address) {
    const bytes = base58check.decode(address);
    if (bytes.length !== 21 || bytes[0] !== PREFIX)
        throw new Error(`Not a Tron address: ${address}`);
    return bytesToHex(bytes.subarray(1));
}
/** 20-byte hex (optionally 0x-, 41- or 32-byte-topic padded) → "T…". */
export function tronAddressFromHex(hex) {
    const clean = hex.replace(/^0x/, "").toLowerCase();
    const body = clean.length === 42 && clean.startsWith("41") ? clean.slice(2) : clean.slice(-40);
    if (!/^[0-9a-f]{40}$/.test(body))
        throw new Error(`Not a 20-byte hex address: ${hex}`);
    return base58check.encode(Uint8Array.from([PREFIX, ...hexToBytes(body)]));
}
//# sourceMappingURL=tron-address.js.map